import { NextImg } from '@bfa/common-ui';
import React from 'react';

const testId = 'popup-hero-image';

const HeroImage = ({ image }: { image: { src: string; alt: string } }) =>
  image ? (
    <NextImg
      layout="responsive"
      images={[
        {
          src: image.src,
          alt: image.alt,
          width: 558,
          height: 320,
          'data-testid': testId,
        },
      ]}
      priority
    />
  ) : null;

export default HeroImage;
